import StatusCard from "./StatusCard";
import type { StatusCardData } from "../../interfaces/componentInterfaces/jobDetails";

interface StatusCardsGridProps {
  cards: StatusCardData[];
  onPreview?: (type: string) => void;
  onDownload?: (type: string) => void;
  onDownloadLog?: (type: string) => void;
  onDownloadZip?: (type: string) => void;
}

const StatusCardsGrid = ({
  cards,
  onPreview,
  onDownload,
  onDownloadLog,
  onDownloadZip,
}: StatusCardsGridProps) => {
  return (
    <div className="job-details__cards">
      {cards.map((card) => (
        <StatusCard
          key={card.type}
          title={card.title}
          count={card.count}
          color={card.color}
          type={card.type}
          onPreview={() => onPreview?.(card.type)}
          onDownload={() => onDownload?.(card.type)}
          onDownloadLog={() => onDownloadLog?.(card.type)}
          onDownloadZip={() => onDownloadZip?.(card.type)}
        />
      ))}
    </div>
  );
};

export default StatusCardsGrid;
